// import utils from '../utils'
import Splide from '@splidejs/splide';

function initSlider() {

	const slides = document.querySelectorAll('.smx-carousel');

    slides.forEach((slide) => {
        var splide_obj = slide.querySelector('.splide');
        var layout = JSON.parse(splide_obj.dataset.splideLayout);
        var splide_breakpoints = {};

        Object.entries(layout).forEach(([breakpoint, perPage]) => {
            var width = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--smx-breakpoint-'+breakpoint).replace('px',''));
            if(0 < width){
                splide_breakpoints[width] = {
                    perPage: perPage,
                };
            }
        });

        var carousel = new Splide(splide_obj, {
            type : 'loop',
            mediaQuery: 'min',
            trimSpace: true,
            //focus    : 'center',
            perPage: layout.xs,
            breakpoints: splide_breakpoints,
        });
        
        carousel.mount();
        
    });

}

export default { initSlider };
